import React, { useState } from "react";
import { useDispatch } from "react-redux";

import * as actions from "../StaffUser/_redux/staffUserActions";
// C:\Users\admin\Desktop\CODE\GMBE\gamerji-saas-leagueops\src\app\modules\Users\StaffUser\_redux\staffUserActions.js

 function CreateUserId() {
  const dispatch = useDispatch();
  const [createUserIdstate, setcreateUserIdstate] = useState(true);

  const createUserId = () => {
    // console.log("createUserId->onClick")
    setcreateUserIdstate(false)
    dispatch(actions.createUserIdAction({limit:5000}))
    setTimeout(()=>{
     setcreateUserIdstate(true)
    }, 60000);
 
   };
   const createESignup = () => {
    // console.log("createUserId->onClick")
    setcreateUserIdstate(false)
    dispatch(actions.createSignupMethodAction({limit:5000}))
    setTimeout(()=>{
     setcreateUserIdstate(true)
    }, 30000);
 
   };
   const createBtn=()=>{
    return (
      (createUserIdstate) && (<>
        <button type="button" className="btn btn-dark"
                          onClick={createUserId}
                          style={{ width: '130px', marginTop: '20px', marginLeft:'5px'}}
                        >
                          Create User Id
        </button>
                       
        </>
        ))     

  };
  const createESignupBtn=()=>{
    return (
      (createUserIdstate) && (<>
        <button type="button" className="btn btn-dark"
                          onClick={createESignup}
                          style={{ width: '130px', marginTop: '20px', marginLeft:'5px'}}
                        >
                         SignUpData
        </button>
                       
        </>
        ))     

  };
  return (
   <>
   <h1>CreateUserId</h1>
   {createBtn()}
   {createESignupBtn()}
   </>
  );
}

export default CreateUserId;